// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pushed-baselines{padding-top:30px}#pushed-baselines table{text-align:center}", ""]);
// Exports
module.exports = exports;
